<bim-id class="flex h-full w-full" [project]="getProject()" [user]="user" (createTask)="createTask($event)" (addToFiles)="addToFiles($event)"></bim-id>
